module.exports = __webpack_public_path__ + "static/media/SV3.5fcd7e0e.jpg";